import { createContext, type ReactNode } from "react";

interface ContentType {
    children: ReactNode;
    title?: string;
    customButtons?: boolean;
    disableBlurredBg?: boolean;
    disableXButton?: boolean;
}

interface ModalContextType {
    visible: boolean;
    content: ContentType | null;
    setContent: (content: ContentType) => void;
    openModal: (modalContent: ContentType) => void;
    closeModal: () => void;
    secondaryVisible: boolean;
    secondaryContent: ContentType | null;
    setSecondaryContent: (content: ContentType) => void;
    openSecondaryModal: (modalContent: ContentType) => void;
    closeSecondaryModal: () => void;
    clearModal: () => void;
    showSecondaryOnClose: boolean;
    setShowSecondaryOnClose: (condition: boolean) => void;
    closeOnClickedOutside?: boolean;
    enableCloseOnClickedOutside: () => void;
    disableCloseOnClickedOutside: () => void;
}

export const ModalContext = createContext<ModalContextType>({
    visible: false,
    content: null,
    setContent: () => {},
    openModal: () => {},
    closeModal: () => {},
    secondaryVisible: false,
    secondaryContent: null,
    setSecondaryContent: () => {},
    openSecondaryModal: () => {},
    closeSecondaryModal: () => {},
    clearModal: () => {},
    showSecondaryOnClose: false,
    setShowSecondaryOnClose: () => {},
    closeOnClickedOutside: true,
    enableCloseOnClickedOutside: () => {},
    disableCloseOnClickedOutside: () => {},
});

// Export types for other files to use
export type { ContentType, ModalContextType };
